/**
 * Combat component - handles attack behavior
 */

import type { Entity } from '@/types';

export interface CombatComponent {
  attack: number;
  defense: number;
  range: number;
  attackSpeed: number;
  attackCooldown: number;
  target: Entity | null;
  lastAttackTime: number;
  lastAttacker: Entity | null; // 记录最后攻击者，用于反击
  lastAttackerTime: number; // 记录被攻击时间，用于判断是否过期
}

export function createCombat(
  attack: number,
  defense: number = 0,
  range: number = 1.5,
  attackSpeed: number = 1.0
): CombatComponent {
  return {
    attack,
    defense,
    range,
    attackSpeed,
    attackCooldown: 0,
    target: null,
    lastAttackTime: 0,
    lastAttacker: null,
    lastAttackerTime: 0,
  };
}
